import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/wordb_logo.svg';
import { FaArrowRight } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../components/Footer';
import { IoMdArrowRoundBack } from "react-icons/io";
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import { LuEyeClosed, LuEye } from "react-icons/lu";
import { API } from '../config';


const SignUp = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isSigningUp, setIsSigningUp] = useState(false);

    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open); //Safer when updates depend on previous state.
    const toggleQuery = () => setQueryOpen(open => !open);

    const navigate = useNavigate(); 

    const validateForm = () => {
        //console.log("Validating...");
        let errors = [];

        if (!username.trim()) {
            errors.push("Nickname is required.");           
        }

        if (username.length < 2) {
            errors.push('Nickname must be at least 2 characters.');
        }

        if (username.length > 11) {
            errors.push('Nickname must be fewer than 12 characters.');
        }

        if (password.length < 4) {
            errors.push("Password must be at least 4 characters.");
        }

        if (password !== confirmPassword) {
            errors.push("Passwords do not match.");
        }

        if (username.trim().toLowerCase() === 'bigfoot') {
            errors.push("Nice try... but Bigfoot is already taken. He's kind of a big deal around here.");
        }

        if (errors.length > 0) {
            errors.forEach((error) => toast.error(error)); // Show errors one by one
            return false;
        }



        return true;
    };

    const handleSignUp = async (e) => {
        
        e.preventDefault();
        //console.log("Signing up...")

        if (!validateForm()) {
            return; // Stop submission if validation fails
        }

        setIsSigningUp(true);

        try {
            const res = await axios.post(`${API}/api/users/register`, {
                username: username.trim(),
                password,
            });
                        // --- BEGIN automatic login flow --------------------------------
            const token = res.data.token;           // NEW: expect token back
            localStorage.setItem('authToken', token); // NEW: persist session
            toast.success('Account created successfully!');

            onLogin?.();  // NEW: flip auth flag in <App/> //if onLogin exists, call it; otherwise do nothing.
            navigate('/home');                      // NEW: straight to the game
            // --- END automatic login flow ----------------------------------
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error registering user.');
        } finally {
          // NEW BLOCK: reset submission state
          setIsSigningUp(false);
      }
    };

    return (
        <>
        
            <ToastContainer position="top-right" autoClose={3000} />
            <section className='signup'>
                
                {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
                {isQueryOpen && <Query onClose={toggleQuery} />}

                <Link to="/" className='back-link'>
                    <IoMdArrowRoundBack className='icon' /> 
                </Link>

                <div className="logo-div">
                    <img src={logo} alt="" />
                </div>

                <form className="signup-form" onSubmit={handleSignUp}>
                    {/* Nickname Input */}
                    <div className="form-input">
                        <label htmlFor="nickname">Enter your Nickname</label>
                        <input 
                            type="text" 
                            id="nickname" 
                            name="nickname" 
                            placeholder="Bigfoot" 
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete='off'
                        />
                    </div>


                    {/* Password Input */}
                    <div className="form-input">
                        <label htmlFor="password">Enter your Password</label>
                        <input 
                            type={showPassword ? "text" : "password"}
                            id="password" 
                            name="password" 
                            placeholder="****" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete='off'
                        />
                        <span
                            className="pwd-toggle"
                            onClick={() => setShowPassword(v => !v)}
                        >
                            {showPassword ? <LuEye /> : <LuEyeClosed />}
                        </span>
                    </div>
       

                    {/* Confirm Password Input */}
                    <div className="form-input">
                        <label htmlFor="confirmPassword">Confirm your Password</label>
                        <input 
                            type={showPassword ? "text" : "password"}
                            id="confirmPassword" 
                            name="confirmPassword" 
                            placeholder="****" 
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            autoComplete='off'
                        />
                        <span
                            className="pwd-toggle"
                            onClick={() => setShowPassword(v => !v)}
                        >
                            {showPassword ? <LuEye /> : <LuEyeClosed />}
                        </span>
                    </div>
                   

                    {/* Submit Button */}
                    <button type="submit" className="signup-button">
                        <p className='btn-text'>{ isSigningUp ? 'Creating account...' : 'Sign Up & Play'}</p> <FaArrowRight className="icon"/>
                    </button>

                    {/* Login Link */}
                    <p className="login-text">
                        Already have an account? &nbsp;
                        <Link to="/login" className="login-link">Log in now</Link> 
                    </p>
                </form>

                <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
            </section>

            
        </>
    );
};

export default SignUp;
